var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPortfolio(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-Portfolio"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Portfolio",
    clipPath: "url(#clip-Portfolio)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Iconly_Light-Outline_Profile",
    "data-name": "Iconly/Light-Outline/Profile",
    transform: "translate(3 1)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Profile",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Combined-Shape",
    d: "M10.846,11.088c0,2.257-3.1,2.518-5.422,2.518H5.257C3.774,13.6,0,13.508,0,11.074,0,8.863,2.971,8.568,5.28,8.557h.31C7.073,8.56,10.846,8.654,10.846,11.088Zm-5.422-1.5c-2.918,0-4.4.5-4.4,1.491s1.479,1.5,4.4,1.5,4.4-.5,4.4-1.491S8.341,9.584,5.424,9.584ZM5.424,0a3.636,3.636,0,0,1,0,7.271H5.4A3.636,3.636,0,0,1,5.424,0Zm0,.978A2.658,2.658,0,0,0,5.4,6.294l.02.489V6.294a2.658,2.658,0,0,0,0-5.316Z",
    transform: "translate(0 0)",
    fill: "#a2a2a2",
    fillRule: "evenodd"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPortfolio);
export default __webpack_public_path__ + "static/media/Portfolio.adc98ac2a76f74bffbd172ab2eaebdc9.svg";
export { ForwardRef as ReactComponent };